var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.flag == _vm.index && _vm.detailShow
    ? _c(
        "div",
        {
          staticClass: "transfers-detail",
          style: {
            height:
              _vm.transferDetail.entities && _vm.transferDetail.entities.length
                ? _vm.transferDetail.entities.length * 25 +
                  _vm.detailHeight +
                  "px"
                : _vm.detailHeight + "px"
          }
        },
        [
          _c("div", { staticClass: "transfers-detail-title" }, [
            _vm._v(_vm._s(_vm.$t("language.popup.transferDetails")))
          ]),
          _vm._v(" "),
          _vm.transferDetail.state2.status == 1
            ? _c("div", { staticClass: "detail-count" }, [
                _c("div", { staticClass: "transfer-line" }, [
                  _vm._v(
                    _vm._s(_vm.$t("language.common.countFiles")) +
                      ":(" +
                      _vm._s(_vm.transferDetail.state2.readyFindFileCount) +
                      _vm._s(_vm.$t("language.common.transferFiles")) +
                      "," +
                      _vm._s(
                        _vm._f("formatByte")(
                          _vm.transferDetail.state2.totalBytes
                        )
                      ) +
                      ")"
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "detail-one" }, [
            _c("div", { staticClass: "transfer-line" }, [
              _c(
                "span",
                {
                  staticStyle: { float: "left", cursor: "pointer" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.toSourceCatalog(_vm.transferDetail.state2)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.from")) + ":")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "catelog-color catelog-style",
                  attrs: {
                    title: _vm._f("getBusinessTransferCatalog")(
                      _vm.transferDetail.state2.sourceNode
                    )
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toSourceCatalog(_vm.transferDetail.state2)
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("getBusinessTransferCatalog")(
                              _vm.transferDetail.state2.sourceNode
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "transfer-line" }, [
              _c(
                "span",
                {
                  staticStyle: { float: "left", cursor: "pointer" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.toAimCatalog(_vm.item)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.to")) + ":")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "catelog-color catelog-style",
                  attrs: {
                    title: _vm._f("getBusinessTransferCatalog")(
                      _vm.transferDetail.state2.desNode
                    )
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: { cursor: "pointer" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toAimCatalog(_vm.item)
                        }
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("getBusinessTransferCatalog")(
                              _vm.transferDetail.state2.desNode
                            )
                          ) +
                          " "
                      )
                    ]
                  )
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("transition", { attrs: { name: "coll" } }, [
                _c(
                  "div",
                  { staticClass: "more-transfers" },
                  [
                    _c("businessTransferThreads", {
                      attrs: {
                        threadChange: _vm.threadChange,
                        detailShow: _vm.detailShow,
                        syncItem: _vm.item,
                        flag: _vm.flag,
                        index: _vm.index
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0af9dba2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0af9dba2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabs/tabs_task_list/tabs_businessTransfer_detail.vue
// module id = null
// module chunks = 